import { createAsyncThunk } from '@reduxjs/toolkit'
import { buildUrl, createRequest } from './common/httpUtils'
import { requestFinished, requestStart } from './UI'
import { retrieveResponseErrorMessage } from '../utils/errorUtils'

type UpdateBlueprintNameArgs = {
  groupId: GroupId
  blueprintId: GeneralId
  name: string | null
}

const getErrorMessage = (data: any, fallback: string): string => {
  const validationMessage = data?.errors && typeof data.errors === 'object'
    ? Object.values(data.errors).flat().find((message) => typeof message === 'string')
    : null

  if (typeof validationMessage === 'string') return validationMessage
  if (typeof data?.error_message === 'string') return data.error_message
  if (typeof data?.error === 'string') return data.error
  return fallback || '図面名を更新できませんでした。'
}

const updateBlueprintName = createAsyncThunk<
IBlueprint,
UpdateBlueprintNameArgs,
{
  rejectValue: string
}
>('blueprint/updateName', async (arg, thunkApi) => {
  const { groupId, blueprintId, name } = arg
  const { dispatch, rejectWithValue } = thunkApi

  dispatch(requestStart())

  try {
    const response = await fetch(createRequest(
      buildUrl(`/api/v1/groups/${groupId}/blueprints/${blueprintId}`),
      'PATCH',
      true,
      'application/json',
      {
        blueprint: {
          name,
        },
      },
    ))
    const data = await response.json()

    if (response.status >= 400 || !data.blueprint) {
      return rejectWithValue(getErrorMessage(data, response.statusText))
    }

    return data.blueprint as IBlueprint
  } catch (error: unknown) {
    return rejectWithValue(retrieveResponseErrorMessage(error))
  } finally {
    dispatch(requestFinished())
  }
})

export default updateBlueprintName
